"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleMultiLevelListCommand = void 0;
var tslib_1 = require("tslib");
var numbering_list_1 = require("../../../core/model/numbering-lists/numbering-list");
var control_1 = require("../../../core/model/options/control");
var numbering_list_command_base_1 = require("./numbering-list-command-base");
var ToggleMultiLevelListCommand = (function (_super) {
    tslib_1.__extends(ToggleMultiLevelListCommand, _super);
    function ToggleMultiLevelListCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToggleMultiLevelListCommand.prototype.getNumberingListType = function () {
        return numbering_list_1.NumberingType.MultiLevel;
    };
    ToggleMultiLevelListCommand.prototype.isEnabled = function () {
        return _super.prototype.isEnabled.call(this) && control_1.ControlOptions.isEnabled(this.control.modelManager.richOptions.control.numberingMultiLevel);
    };
    return ToggleMultiLevelListCommand;
}(numbering_list_command_base_1.NumberingListCommandBase));
exports.ToggleMultiLevelListCommand = ToggleMultiLevelListCommand;
